
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 3H1v18h9V3z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.25 6h12m-12 6h12m-12 6h12","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.125 7.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM4.125 13.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM4.125 19.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z","fill":"#4A4A4A"}})])
          )
        }
      }
    